<template>
  <div class="main">
    <a-spin class="load" v-show="loading"/>
    <!--    <div class="top">-->
    <!--      <span class="icon" @click="history">-->
    <!--        <img class="goHistory" src="../../../assets/image/08.png" alt="">-->
    <!--      </span>-->
    <!--      <span class="iconText">备课历史</span>-->
    <div class="breadcrumb">
      <a-breadcrumb>
        <a-breadcrumb-item style="font-size: 16px">
          <router-link :to="'/books/zhunBei'">学前准备</router-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item style="font-size: 16px">备课历史</a-breadcrumb-item>
      </a-breadcrumb>
    </div>
    <!--    </div>-->
    <div class="content">
      <div class="list">
        <a-list item-layout="vertical"
                size="large"
                :data-source="prepareData">
          <a-list-item slot="renderItem" key="item.title" slot-scope="item">
            <a-list-item-meta :description="item.description">
              <div slot="title" class="item">
                <a-row class="rowTitle">
                  <a-col :span="20"></a-col>
                  <a-col class="colButton" :span="4" v-if="item.id==null || item.id == '' || item.id=='undefined'">
                    <a-button class="useTo" disabled>使用</a-button>
                  </a-col>
                  <a-col class="colButton" :span="4" v-else>
                    <a-button class="useTo" @click="use(item)">使用</a-button>
                  </a-col>
                </a-row>
                <a-row class="rowText">
                  <a-col class="colText">
                    <div class="prepare-content">
                      <p v-html="item.content"></p>
                    </div>
                    <div class="imgView">
                      <div v-if="item.imageList!=null" style="text-align:left;">
                        <!--                        <a-carousel arrows dots-class="slick-dots slick-thumb" :autoplay="autoplay">-->
                        <!--                          <a slot="customPaging" slot-scope="props">-->
                        <!--                            <img :src="resBasePath+'/'+item.imageList[props.i].path" />-->
                        <!--                          </a>-->
                        <!--                          <div v-for="img in item.imageList" :key="img.id">-->
                        <!--                            <img :src="resBasePath +'/'+ img.path" />-->
                        <!--                            <p v-if="img.name">{{img.name}}</p>-->
                        <!--                          </div>-->
                        <!--                        </a-carousel>-->
                        <rich-text-view
                            :key="new Date().getTime()"
                            :content='item&&item.answerContent'
                            :images="item.imageList||[]"
                        ></rich-text-view>
                      </div>
                      <div class="videoDetail" v-if="item.videoList!=null" style="text-align:left;">
                        <!--                        <a-carousel arrows dots-class="slick-dots slick-thumb" :autoplay="autoplay">-->
                        <!--                          <a slot="customPaging" slot-scope="props">-->
                        <!--                            <img v-if="item.videoList[props.i].coverPath!=null" :src="resBasePath+'/'+item.videoList[props.i].coverPath" />-->
                        <!--                          </a>-->
                        <!--                          &lt;!&ndash; <div class="videoItem" v-for="i in item.videoList" :key="i.id" >-->
                        <!--                            <video v-if="i.path.split('.')[1]=='mp4'" class="videoPlay" controlslist="nodownload" :disablePictureInPicture="true" :src="resBaseVideo+'/'+i.path" controls="controls" :poster="i.coverPath"></video>-->
                        <!--                            <ts-video v-if="i.path.split('.')[1]=='m3u8'"  :poster="resBasePath+'/'+i.coverPath" :vPath="resBaseVideo+'/'+i.path"> </ts-video>-->
                        <!--                          </div> &ndash;&gt;-->
                        <!--                          <div class="videoItem">-->
                        <!--                            <ts-new :videos="item.videoList"></ts-new>-->
                        <!--                          </div>-->
                        <!--                        </a-carousel>-->
                        <rich-text-view
                            :key="new Date().getTime()"
                            :content='item&&item.answerContent'
                            :videos="item.videoList||[]"
                        ></rich-text-view>
                      </div>
                      <div v-if="item.audioList!=null" style="text-align:left;">
                        <!--                        <div class="audioDiv" v-for="audio in item.audioList" :key="audio.id">-->
                        <!--                          <audio controls class="audioWidth" :src="resBasePath+'/'+audio.path"/>-->
                        <!--                          <p v-if="audio.name">{{'音频'+audio.name}}</p>-->
                        <!--                        </div>-->
                        <rich-text-view
                            :key="new Date().getTime()"
                            :content='item&&item.answerContent'
                            :audios="item.audioList||[]"
                        ></rich-text-view>
                      </div>
                    </div>
                    <div class="class_info">
                      <div class="class_fabu">已发布至</div>
                      <div class="class_bj">
                        <div class="class_banji" v-for="(ite,inde) in item.classList" :key="inde" :title="ite">{{ ite }}
                        </div>
                      </div>
                      <div class="release_time">{{ format.format(item.createDate) }}</div>
                    </div>
                  </a-col>
                </a-row>
              </div>
            </a-list-item-meta>
          </a-list-item>
        </a-list>
      </div>
      <div style="text-align:center;margin:15px 0px;">
        <a-config-provider>
          <a-pagination :default-current="1" :page-size="pageSize"
                        @change="handleListChange"
                        :total='total'/>
        </a-config-provider>
      </div>
    </div>
  </div>
</template>

<script>
import format from '../../../utils/format.js'
// import HanIcon from '../components/Icon.vue'
import Card from '../components/card.vue'
import tsVideo from '../components/tsvideo.vue'
import tsNew from '../components/tsNew.vue'
import RichTextView from "../../../components/richTextView.vue";

export default {
  name: 'BeiKe',
  data() {
    return {
      format,
      autoplay: true,
      loading: true,
      defaultOpen: '公开',
      selectOpen: [{value: '公开', key: '1'}, {value: '私密', key: '2'}, {value: '仅班级可见', key: '3'}],
      resBasePath: this.$resBasePath,
      resBaseVideo: this.$resBaseVideo,
      pagination: {
        onChange: page => {
          // console.log(page)
        },
      },
      prepareData: [],
      total: 0,
      pageSize: 5,
      pageNum: 1,
    }
  },
  components: {
    Card,
    // HanIcon,
    tsVideo,
    tsNew,
    RichTextView
  },
  created() {

  },
  watch: {
    mlVisible() {

    }
  },
  mounted() {
    this.getParpre()
  },
  methods: {
    history() {
      this.$router.go(-1)
    },
    handleListChange(current, pageSize) {
      this.pageNum = current
      this.pageSize = pageSize
      this.getParpre()
    },
    getParpre() { // 获取教师学前准备
      const bookId = localStorage.getItem('syzg-bookId')
      const param = {
        bookId: bookId,
        styleId: localStorage.getItem('styleId'),
        teacherId: this.$getUserInfo().id,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      }
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/study/getTeacherPreStudyHistory',
        body: param
      }).loading(
          () => (this.loading = true),
          () => (this.loading = false)
      ).done(res => {
        if (res && res.success && res.resultCode === 0) {
          this.prepareData = res.resultData.list
          this.total = res.resultData.total
        }
      })
    },
    use(item) { //使用推荐资源
      //console.log(item)
      const param = {
        id: item.id,
        userId: this.$getUserInfo().id
      }
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/study/useHistoryPreStudy',
        body: param
      }).loading(
          () => (this.loading = true),
          () => (this.loading = false)
      ).done(res => {
        if (res && res.success && res.resultCode === 0) {
          this.$message.success('使用成功')
          this.getParpre()
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.main {
  // height: 110px;
  // background-color: #fff;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  margin-left: -105px;

  .breadcrumb {
    width: 1240px;
    margin: 0 auto;
  }

  .load {
    position: absolute;
    top: 45%;
    left: 50%;
    transform: translate(50%, 50%);
    z-index: 99;
  }

  .top {
    height: 50px;
    background-color: #fff;
    position: relative;
    width: 1240px;
    margin: 0 auto;

    .goHistory {
      width: 8px;
      height: 16px;
      cursor: pointer;
    }

    .icon {
      position: absolute;
      top: 45%;
      margin-top: -7px;
      left: 50px;
    }

    .iconText {
      position: absolute;
      top: 45%;
      margin-top: -10px;
      left: 70px;
      color: #9d9292;
      font-size: 18px;
    }
  }

  .content {
    //min-height: 1200px;
    width: 1240px;
    background: #fff;
    border-radius: 8px;
    //width: 1240px;
    margin: 20px auto;
    padding-top: 30px;
    height: calc(100vh - 185px);

    .list{
      overflow-y: auto;
      height: calc(100vh - 275px);
    }

    .item {
      background: #F1F0F0;
      border-radius: 6px;
      padding: 20px;
    }

    .rowTitle {
      .colButton {
        text-align: right;

        .useTo {
          width: 80px;
          height: 30px;
          line-height: 30px;
          background: @primary-color;
          border-radius: 4px;
          color: #fff;
        }
      }
    }

    .rowText {
      margin-top: 10px;

      .colText {
        p {
          color: #040506;
          font-size: 16px;
        }
      }

      .list {
        margin-top: 5px;

        .listRow {
          .listCol {
            width: 33.33%;

            .imageB {
              height: 180px;
            }
          }
        }
      }

      .class_info {
        margin-top: 20px;

        .class_fabu {
          margin-top: 5px;
          width: 64px;
          height: 20px;
          font-family: PingFangSC-Regular;
          font-size: 16px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 20px;
          letter-spacing: 0px;
          color: #867d7b;
          float: left;
        }

        .class_bj {
          width: 900px;
          float: left;

          .class_banji {
            display: inline-block;

            margin-left: 20px;
            // width: 130px;
            height: 28px;
            line-height: 28px;
            background-color: #a3af9059;
            border-radius: 16px;
            text-align: center;
            color: #a3af90;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            cursor: pointer;
            padding-left: 10px;
            padding-right: 10px;
          }
        }

        .release_time {
          float: right;
          font-size: 16px;
          color: #867d7b;
        }
      }
    }
  }
}

/deep/ .ant-list-pagination {
  text-align: center;
  padding-bottom: 20px;
  margin-bottom: 10px;
}

/deep/ .ant-list-vertical .ant-list-item-meta {
  margin-bottom: 0px;
}

/deep/ .ant-list-split .ant-list-item {
  // border-bottom: 10px solid #f1f0f0;
  padding: 20px 30px 20px 30px;
  border-radius: 10px;
  background: #FFFFFF;
  margin-bottom: 10px;
}

/deep/ .ant-list-something-after-last-item
.ant-spin-container
> .ant-list-items
> .ant-list-item:last-child {
  border-bottom: 10px solid #f1f0f0;
}

.prepare-content,
.task-item {
  width: 100%;
  height: 100%;
  // background-color: white;
  border-radius: @border-radius-base;
  font-size: 20px;
  color: #040506;
  white-space: pre-wrap;
  font-weight: normal;
  font-stretch: normal;
}

.imgView {
  padding: 0 50px;

  .videoPlay {
    height: 150px;
    width: 100%;
    outline-style: none;
  }

  img {
    width: 100%;
    height: 100%;
  }
}

/deep/ .ant-carousel {
  text-align: center;
  width: 800px;
  margin: auto;
}

.videoDetail {
  .videoItem {
    display: inline-block;
    width: 640px;

    .videoPlay {
      width: 100%;
      height: 450px;
    }
  }
}

.audioDiv {
  margin: 10px 0px;

  .audioWidth {
    width: 500px;
  }
}

/deep/ .ant-carousel .slick-dots {
  height: auto;
}

/deep/ .ant-carousel .slick-slide img {
  border: 5px solid #fff;
  display: block;
  margin: auto;
  width: 100%;
  height: auto;
}

/deep/ .ant-carousel .slick-thumb {
  bottom: -45px;
}

/deep/ .ant-carousel .slick-thumb li {
  width: 60px;
  height: 45px;
}

/deep/ .ant-carousel .slick-thumb li img {
  border: 2px solid #CCC;
  width: 100%;
  height: 100%;
  filter: grayscale(100%);
}

/deep/ .ant-carousel .slick-thumb li.slick-active img {
  border: 2px solid #db5647;
  filter: grayscale(0%);
}

/deep/ .ant-list-split .ant-list-item {
  border-bottom: 1px solid #fff;
}

/deep/ .ant-list-split .ant-list-item {
  padding: 0px 30px 0px 30px;
  border-radius: 10px;
  background: #FFFFFF;
}

/deep/ .ant-pagination {
  padding-bottom: 20px;
}
</style>
